import { render, staticRenderFns } from "./CollegeStream.vue?vue&type=template&id=280dd5b2&"
import script from "./CollegeStream.vue?vue&type=script&lang=js&"
export * from "./CollegeStream.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports